module.exports = __webpack_public_path__ + "0c43090776c0a6b433f0d7c6926a8c8a.png";